import React, { useState, useRef } from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { haptic } from '../utils/haptics';

const THRESHOLD = 36;

export const PullToRefresh = ({ onRefresh, children }) => {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(null);
  const fired = useRef(false);

  const onTouchStart = (e) => {
    startY.current = window.scrollY <= 0 ? e.touches[0].clientY : null;
    fired.current = false;
  };

  const onTouchMove = (e) => {
    if (startY.current == null || refreshing) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0 && window.scrollY <= 0) {
      const damped = Math.min(dy * 0.4, 90);
      setPull(damped);
      if (damped >= THRESHOLD && !fired.current) {
        fired.current = true;
        haptic(12);
      }
    } else {
      setPull(0);
    }
  };

  const onTouchEnd = async () => {
    if (pull >= THRESHOLD && !refreshing) {
      setRefreshing(true);
      setPull(THRESHOLD);
      try {
        await onRefresh?.();
      } finally {
        setRefreshing(false);
        setPull(0);
      }
    } else {
      setPull(0);
    }
    startY.current = null;
  };

  return (
    <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} data-testid="pull-to-refresh">
      <div
        className="flex justify-center overflow-hidden transition-[height] duration-150"
        style={{ height: pull > 4 || refreshing ? `${Math.max(pull, refreshing ? THRESHOLD : 0)}px` : '0px' }}
        aria-hidden="true"
      >
        <div className="flex items-center">
          <span className="w-9 h-9 flex items-center justify-center bg-white dark:bg-neutral-800 border-2 border-black shadow-[2px_2px_0px_#000] rounded-full">
            <ArrowsClockwise
              size={18}
              weight="bold"
              className={`text-[#2B4C6F] ${refreshing ? 'animate-spin' : ''}`}
              style={!refreshing ? { transform: `rotate(${pull * 3}deg)` } : undefined}
            />
          </span>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PullToRefresh;
